import React from 'react';
import '../App.css';

function Loader() {
    return (
        <div className="flex justify-center items-center h-full">
            <div className="loader"></div>
        </div>
    );
}

export default Loader;